/* global localStorage */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { replace } from "../history";

import Loading from "../components/Loading";
import EditSite from "./EditSite";
import Content from "./Content";
import Users from "./Users";
import Sidebar from "./Sidebar";
import Sheets from "./Sheets";

import { change } from "../actions/sites";

@connect(({ auth, sites }, { match }) => ({
  auth,
  sites: sites.sites,
  current: sites.current,
}))
export default class Main extends Component {
  static childContextTypes = {
    account: PropTypes.object,
    site: PropTypes.object,
    user: PropTypes.object,
  };

  state = {
    loading: true,
  };

  getChildContext() {
    const { current, auth } = this.props;

    return {
      account: auth.account,
      user: auth.user,
      site: current,
    };
  }

  gotoSite = async (site) => {
    const { dispatch } = this.props;

    localStorage.setItem("currentSite", site.id);
    this.setState({ loading: true });
    await dispatch(change(site));
    this.setState({ loading: false });
  };

  componentDidMount() {
    const { match, sites } = this.props;
    const site = sites.find((site) => site.id === match.params.siteId);

    if (site) {
      this.gotoSite(site);
    } else {
      localStorage.removeItem("currentSite");
      replace("/dashboard");
    }
  }

  componentWillReceiveProps(props) {
    if (this.state.loading) return;

    const { current, match, sites } = props;
    const nextSite = sites.find((site) => site.id === match.params.siteId);

    if (!nextSite) {
      localStorage.removeItem("currentSite");
      replace("/dashboard");
      return;
    }

    if (current && current.id !== nextSite.id) {
      // user switched sites
      this.gotoSite(nextSite);
    }
  }

  render() {
    const { match, current } = this.props;
    const { loading } = this.state;

    if (loading)
      return (
        <main>
          <Loading type="container" />
        </main>
      );

    return (
      <main>
        {current && <Sidebar />}
        <section className="container">
          <Switch>
            <Route path="/:siteId/content" component={Content} />
            <Route path="/:siteId/users" component={Users} />
            <Route path="/:siteId/edit" component={EditSite} />
            <Redirect exact path={match.url} to={`${match.url}/content`} />
          </Switch>
          {current && <Sheets />}
        </section>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/Main.js